import  React, { useRef, useEffect, useState } from 'react'
import { Redirect } from 'react-router'

const AgendaLoggerComponent = props => {
  const { clientId, userId } = props
  const [redirect, setRedirect] = useState(null)
  
  const handleRedirect = (location) => {
    if (!!AgendaLogger.unmount && typeof AgendaLogger.unmount === 'function') {
      AgendaLogger.unmount()
      setTimeout(() => {
        // wait for render to finish after logger unmount is called before redirecting
        // might be better to use a promise in case the unmount call takes more than 1 frame
        setRedirect(location)
      }, 0)
    }
  }

  // imported in MountWrapper.js so it only loads once
  const AgendaLogger = window.AgendaLogger
  const loggerRef = useRef(null)
  const htmlEl = document.documentElement
  useEffect(() => {
    if (loggerRef.current) {
      htmlEl.style.fontSize = 'initial'
      AgendaLogger.launch({clientId, userId, dashboardRedirect: handleRedirect})
    }
    htmlEl.style.fontSize = 'initial'
    AgendaLogger.launch({clientId, userId, dashboardRedirect: handleRedirect})
    return () => {
      // reset html font-size and destroy logger on unmount
      htmlEl.style.fontSize = '10px'
    }
  }, [loggerRef])

  if (redirect) {
    return <Redirect to={redirect} />
  }
  return <div id="inv-logger" ref={loggerRef}>
    {/* logger is mounted here */}
  </div>
}

const LoggerRoute = (api, socket, opts, match) => {
  return () => {
      // return <div id="inv-logger">
        return <AgendaLoggerComponent clientId={opts.credentials.clientID} userId={opts.credentials.userID}/>
      // </div>
  }
};

export default LoggerRoute
